/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家审核管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入商家名称"></el-input>
      </el-form-item>
	  <el-form-item label="门店编号">
	    <el-input size="small" v-model="formInline.mchCode" placeholder="输入门店编号"></el-input>
	  </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="mchId" label="id" width="150">
      </el-table-column>
      <el-table-column prop="name" label="商家名称" width="200">
      </el-table-column>
      <el-table-column prop="cityName" label="城市">
      </el-table-column>
      <el-table-column prop="mchCode" label="门店编号">
      </el-table-column>
      <el-table-column prop="addr" label="餐厅地址" width="200">
      </el-table-column>
      <el-table-column prop="rateBase" label="基础折扣">
      </el-table-column>
      <el-table-column prop="rateSale" label="销售折扣">
      </el-table-column>
      <el-table-column prop="ver" label=" 版本号">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="500">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row.mchId,1)">审核</el-button>
          <el-button size="mini" @click="handleEdit(scope.row.mchId,4)">修改基础信息</el-button>
          <el-button size="mini" v-if="scope.row.groupId==300 " @click="handleEdit(scope.row.mchId,2)">修改银行卡</el-button>
          <el-button size="mini" v-if="scope.row.groupId==300 " @click="handleEdit(scope.row.mchId,3)">修改商家储值信息
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="商家名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入商家名称"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="addr">
          <el-input size="small" v-model="editForm.addr" auto-complete="off" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="城市" prop="name">
          <el-select v-model="editForm.cityId" filterable remote placeholder="请输入关键词" size="medium"
            @change="getAreaList" :remote-method="getCityList">
            <el-option v-for="item in options" :key="item.cityId" :label="item.cityName" :value="item.cityId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="name">
          <el-select v-model="editForm.areaId" placeholder="请选择区域">
            <el-option v-for="item in arealist" :key="item.areaId" :label="item.areaName" :value="item.areaId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="name">
          <el-select style="width:100%" v-model="editForm.groupId" filterable remote placeholder="请输入关键词" size="medium"
            :remote-method="getMchGroupListPage">
            <el-option v-for="item in jituan" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getMerchantListPage,
    getMchGroupListPage,
    getAreaList,
    getCityList,
    addMerchant
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          userId: JSON.parse(localStorage.getItem('userdata')).muId,
          name: '',
          addr: '',
          areaId: "",
          cityId: '',
          groupId: ""
        },
        options: '',
        arealist: [],
        businessAreaIdlist: [],

        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
		   mchCode:'',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        },
        jituan: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.formInline.page = 1
      this.getdata(this.formInline)
      this.getMchGroupListPage()
      this.getCityList()
    },
    methods: {
      getCityList(query) {
        this.options = []

        let pro = {
          "name": query,
        }
        getCityList(pro).then(res => {
          this.options = res.data
          console.log(this.options)
        })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          "name": parameter.varName,
		  "mchCode": parameter.mchCode,
		  
          state: 9,
          cityId: localStorage.getItem('cityId1')

        }
        getMerchantListPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      getMchGroupListPage(query) {
        this.jituan = []
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": 1,
          "pageSize": 10,
          name: query
        }
        getMchGroupListPage(pro)
          .then(res => {
            if (res.code == 0) {
              this.jituan = res.data.list
              this.jituan.unshift({
                groupId: 0,
                groupName: '暂无'
              })
            }
          })
      },
      getAreaList(query) {
        console.log(this.editForm)
        let pro = {
          cityId: this.editForm.cityId
        }
        getAreaList(pro).then(res => {
          this.arealist = res.data
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(row, type) {
        if (type == 1) {
          console.log()
          this.$router.push({
            name: '商家审核详情',
            query: {
              id: row
            }
          })
        } else if (type == 2) {
          this.$router.push({
            name: '修改银行卡',
            query: {
              id: row
            }
          })
        } else if (type == 3) {
          this.$router.push({
            name: '修改商家储值信息',
            query: {
              id: row
            }
          })
        } else if (type == 4) {
          const {
            href
          } = this.$router.resolve({
            path: '/bus/modifyMerchantsBasis',
            query: {
              id: row
            }
          })
          window.open(href, '_blank')
        }
      },
      //显示编辑界面
      handleEdit1(index, row) {
        this.editFormVisible = true
        this.title = '添加'
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.loading = true
        let pro = this.editForm
        addMerchant(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
              this.getdata(this.formInline)
              this.closeDialog()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }


    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/audit.vue